import { addUniqueValue, convertToObject, HTTP_VERB } from "../../../lib/utils"
import apiServerConstants from "../apiServerConstants"
import { makeSagaQuery } from "../utils"
import * as ItemTypes from "../../items/types"
import moment from "moment"
import { all, call, put, select, takeEvery } from "redux-saga/effects"
import { DckActionTypes, DckSelectors } from "dck-redux"
import apiServerApi from "../apiServerApi"
import store from "store"

function manageFinancierBatchItem(item) {

  const { createdOn, affiliation = {}, loans = [], sellingCost, purchaseCost,
   commissionFee, transportFee } = item

  item.createdOnFormatted = createdOn ? moment(createdOn).format('ll') : ''
  item.affiliationName = `${affiliation.name} - ${affiliation.businessId}`
  item.nbLoans = loans.length
  item.otherCosts = commissionFee + transportFee
  item.margin = item.nbLoans ? sellingCost - (purchaseCost + item.otherCosts) : 0

  return item
}

function manageFinancierBucketItem(item) {

  const { createdOn, batches = [], amount, sellingCost, purchaseCost,
    commissionFee, transportFee } = item

  item.createdOnFormatted = createdOn ? moment(createdOn).format('ll') : ''
  item.nbBatches = batches.length
  item.isFull = amount && amount <= purchaseCost
  item.otherCosts = commissionFee + transportFee
  item.balance = amount ? amount - (purchaseCost + item.otherCosts) : 0
  item.margin = amount ? sellingCost - (purchaseCost + item.otherCosts) : 0

  return item
}

function manageInvestorItem(item) {

  const { createdOn } = item
  item.createdOnFormatted = createdOn ? moment(createdOn).format('ll') : ''
  return item
}

function manageInvestorPaymentItem(item) {

  const { investor: { name } = {}, createdOn } = item
  item.investorName = name
  item.createdOnFormatted = createdOn ? moment(createdOn).format('ll') : ''
  return item
}

function *loadFinancierBatchesSaga() {

  const affiliationNames = []

  yield makeSagaQuery(
    `${apiServerConstants.host}/financierbatch?page=${0}&size=${1000000}`, 
    HTTP_VERB.GET,
    null,
    ItemTypes.FinancierBatch,
    true,
    response => {

      let batches = response.body
      if (!(batches instanceof Array)) return

      batches = batches.map(item => {

        const elt = manageFinancierBatchItem(item),
        { affiliationName } = elt
        addUniqueValue(affiliationNames, affiliationName)

        return elt
      })

      return {
        type: DckActionTypes.ITEMS_SET,
        itemType: ItemTypes.FinancierBatch,
        data: batches
      }
    }
  )

  yield put({
    type: DckActionTypes.ITEMS_SET,
    itemType: ItemTypes.FinancierAffiliationFilter,
    data: [ convertToObject(affiliationNames) ]
  })
}

function *loadFinancierBucketsSaga() {

  yield makeSagaQuery(
    `${apiServerConstants.host}/financierbucket?page=${0}&size=${1000000}`, 
    HTTP_VERB.GET,
    null,
    ItemTypes.FinancierBucket,
    true,
    response => {

      let buckets = response.body
      if (!(buckets instanceof Array)) return
      buckets = buckets.map(manageFinancierBucketItem)

      return {
        type: DckActionTypes.ITEMS_SET,
        itemType: ItemTypes.FinancierBucket,
        data: buckets
      }
    }
  )
}

function *reloadFinancierBatch({ id }) {

  try {
    const state = store.get("sessionData"),
    data = (yield call(apiServerApi.getFinancierBatch, state.access_token, id)).body
    yield call(setFinancierBatch, { id, data })
  }
  catch (e) {
    console.error(e)
  }
}

function *setFinancierBatch({ id, data }) {

  const batches = yield select(state =>
    DckSelectors.selectAllItems(state, ItemTypes.FinancierBatch)),

  index = batches.findIndex(elt => elt.id === id),
  fullData = manageFinancierBatchItem(data)

  if (index > -1) {
    batches[index] = fullData
  }
  else {
    batches.push(fullData)
  }

  yield put({
    type: DckActionTypes.ITEMS_SET,
    itemType: ItemTypes.FinancierBatch,
    data: batches
  })
}

function *reloadFinancierBucket({ id }) {

  try {
    const state = store.get("sessionData"),
    data = (yield call(apiServerApi.getFinancierbucket, state.access_token, id)).body
    yield call(setFinancierBucket, { id, data })
  }
  catch (e) {
    console.error(e)
  }
}

function *setFinancierBucket({ id, data }) {

  const buckets = yield select(state =>
    DckSelectors.selectAllItems(state, ItemTypes.FinancierBucket)),
  index = buckets.findIndex(elt => elt.id === id),
  fullData = manageFinancierBucketItem(data)

  if (index > -1) {
    buckets[index] = fullData
  }
  else {
    buckets.push(fullData)
  }

  yield put({
    type: DckActionTypes.ITEMS_SET,
    itemType: ItemTypes.FinancierBucket,
    data: buckets
  })
}

function *removeFinancierBatch({ id }) {

  let batches = yield select(state =>
    DckSelectors.selectAllItems(state, ItemTypes.FinancierBatch))
  batches = batches.filter(elt => elt.id !== id)

  yield put({
    type: DckActionTypes.ITEMS_SET,
    itemType: ItemTypes.FinancierBatch,
    data: batches
  })
}

function *removeFinancierBucket({ id }) {

  let buckets = yield select(state =>
    DckSelectors.selectAllItems(state, ItemTypes.FinancierBucket))
  buckets = buckets.filter(elt => elt.id !== id)

  yield put({
    type: DckActionTypes.ITEMS_SET,
    itemType: ItemTypes.FinancierBucket,
    data: buckets
  })
}

function *loadInvestorsSaga() {

  yield makeSagaQuery(
    `${apiServerConstants.host}/investors?page=${0}&size=${1000000}`, 
    HTTP_VERB.GET,
    null,
    ItemTypes.Investor,
    true,
    response => {

      let investors = response.body
      if (!(investors instanceof Array)) return
      investors = investors.map(manageInvestorItem)

      return {
        type: DckActionTypes.ITEMS_SET,
        itemType: ItemTypes.Investor,
        data: investors
      }
    }
  )
}

function *reloadInvestor({ id }) {

  try {
    const state = store.get("sessionData"),

    data = (yield call(apiServerApi.getInvestor, state.access_token, id)).body
    data.payments = (yield call(apiServerApi.getPaymentByInvestor, state.access_token, id)).body

    yield call(setInvestor, { id, data })
  }
  catch (e) {
    console.error(e)
  }
}

function *setInvestor({ id, data }) {

  const investors = yield select(state =>
    DckSelectors.selectAllItems(state, ItemTypes.Investor)),

  index = investors.findIndex(elt => elt.id === id),
  fullData = manageInvestorItem(data)

  if (index > -1) {
    investors[index] = fullData
  }
  else {
    investors.push(fullData)
  }

  yield put({
    type: DckActionTypes.ITEMS_SET,
    itemType: ItemTypes.Investor,
    data: investors
  })
}

function *removeInvestor({ id }) {

  let investors = yield select(state =>
    DckSelectors.selectAllItems(state, ItemTypes.Investor))
    investors = investors.filter(elt => elt.id !== id)

  yield put({
    type: DckActionTypes.ITEMS_SET,
    itemType: ItemTypes.Investor,
    data: investors
  })
}

function *loadInvestorPaymentsSaga() {

  yield makeSagaQuery(
    `${apiServerConstants.host}/investorpayment?page=${0}&size=${1000000}`, 
    HTTP_VERB.GET,
    null,
    ItemTypes.InvestorPayment,
    true,
    response => {

      let payments = response.body
      if (!(payments instanceof Array)) return
      payments = payments.map(manageInvestorPaymentItem)

      return {
        type: DckActionTypes.ITEMS_SET,
        itemType: ItemTypes.InvestorPayment,
        data: payments
      }
    }
  )
}

function *reloadInvestorPayment({ id }) {

  try {
    const state = store.get("sessionData"),
    data = (yield call(apiServerApi.getInvestorPayment, state.access_token, id)).body
    yield call(setInvestorPayment, { id, data })
  }
  catch (e) {
    console.error(e)
  }
}

function *setInvestorPayment({ id, data }) {

  const payments = yield select(state =>
    DckSelectors.selectAllItems(state, ItemTypes.InvestorPayment)),

  index = payments.findIndex(elt => elt.id === id),
  fullData = manageInvestorPaymentItem(data)

  if (index > -1) {
    payments[index] = fullData
  }
  else {
    payments.push(fullData)
  }

  yield put({
    type: DckActionTypes.ITEMS_SET,
    itemType: ItemTypes.InvestorPayment,
    data: payments
  })
}

function *removeInvestorPayment({ id }) {

  let payments = yield select(state => DckSelectors.selectAllItems(state, ItemTypes.InvestorPayment))
  payments = payments.filter(elt => elt.id !== id)

  yield put({
    type: DckActionTypes.ITEMS_SET,
    itemType: ItemTypes.InvestorPayment,
    data: payments
  })
}

function* FinanciersSaga() {

  yield all([
    takeEvery(
      action =>
        action.type === DckActionTypes.ITEMS_LOAD &&
        action.itemType === ItemTypes.FinancierBatch,
      loadFinancierBatchesSaga
    ),

    takeEvery(
      action =>
        action.type === DckActionTypes.ITEMS_LOAD &&
        action.itemType === ItemTypes.FinancierBucket,
      loadFinancierBucketsSaga
    ),

    takeEvery(
      action =>
        action.type === DckActionTypes.ITEM_SET &&
        action.itemType === ItemTypes.FinancierBatch,
      setFinancierBatch
    ),

    takeEvery(
      action =>
        action.type === DckActionTypes.ITEM_SET &&
        action.itemType === ItemTypes.FinancierBucket,
      setFinancierBucket
    ),

    takeEvery(
      action =>
        action.type === DckActionTypes.ITEM_RELOAD &&
        action.itemType === ItemTypes.FinancierBatch,
      reloadFinancierBatch
    ),

    takeEvery(
      action =>
        action.type === DckActionTypes.ITEM_RELOAD &&
        action.itemType === ItemTypes.FinancierBucket,
      reloadFinancierBucket
    ),

    takeEvery(
      action =>
        action.type === DckActionTypes.ITEM_REMOVE &&
        action.itemType === ItemTypes.FinancierBatch,
      removeFinancierBatch
    ),

    takeEvery(
      action =>
        action.type === DckActionTypes.ITEM_REMOVE &&
        action.itemType === ItemTypes.FinancierBucket,
      removeFinancierBucket
    ),

    takeEvery(
      action =>
        action.type === DckActionTypes.ITEMS_LOAD &&
        action.itemType === ItemTypes.Investor,
      loadInvestorsSaga
    ),

    takeEvery(
      action =>
        action.type === DckActionTypes.ITEM_RELOAD &&
        action.itemType === ItemTypes.Investor,
      reloadInvestor
    ),

    takeEvery(
      action =>
        action.type === DckActionTypes.ITEM_SET &&
        action.itemType === ItemTypes.Investor,
      setInvestor
    ),

    takeEvery(
      action =>
        action.type === DckActionTypes.ITEM_REMOVE &&
        action.itemType === ItemTypes.Investor,
      removeInvestor
    ),

    takeEvery(
      action =>
        action.type === DckActionTypes.ITEMS_LOAD &&
        action.itemType === ItemTypes.InvestorPayment,
      loadInvestorPaymentsSaga
    ),

    takeEvery(
      action =>
        action.type === DckActionTypes.ITEM_RELOAD &&
        action.itemType === ItemTypes.InvestorPayment,
      reloadInvestorPayment
    ),

    takeEvery(
      action =>
        action.type === DckActionTypes.ITEM_SET &&
        action.itemType === ItemTypes.InvestorPayment,
      setInvestorPayment
    ),

    takeEvery(
      action =>
        action.type === DckActionTypes.ITEM_REMOVE &&
        action.itemType === ItemTypes.InvestorPayment,
      removeInvestorPayment
    ),
  ])
}

export default FinanciersSaga



// WEBPACK FOOTER //
// ./src/redux/sagas/items/financiers.js